import React, { useEffect, useState } from "react";
import { Link, useLocation } from 'react-router-dom';
import { mobileMenuItems } from "../constants/mobileMenu";
import { getNumberMessagesTalent, setMessages, setChatSelected, setStaffSelected, setJobSelected, setOpenChatListModal, setIsNewChatFormOtherScreen } from "reducers/chatMessage";
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { setIsSameChatSelected, setIsPaging, setIsLoadNewListChat } from "reducers/chatMessage";
import { setShowReferralPopup } from "reducers/friendInvitation";
import FriendReferralPopup from "../pages/talent_home/components/FriendReferralPopup";
import friendImg1 from "../../assets/svg/friend_illust_1.svg";
import friendImg2 from "../../assets/svg/friend_illust_2.svg";
import qrBackground from "../../assets/svg/qr_bg.svg";

const defaultMenuItems = [
  {
    name: "ホーム",
    path: "/talent",
    childPath: [
      "/talent/news/:id",
    ],
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_18071_6078)">
          <path d="M6 18C6 18.5523 6.44772 19 7 19H8C8.55228 19 9 18.5523 9 18V14C9 13.4477 9.44772 13 10 13H14C14.5523 13 15 13.4477 15 14V18C15 18.5523 15.4477 19 16 19H17C17.5523 19 18 18.5523 18 18V10.5C18 10.1852 17.8518 9.88885 17.6 9.7L12.6 5.95C12.2444 5.68333 11.7556 5.68333 11.4 5.95L6.4 9.7C6.14819 9.88885 6 10.1852 6 10.5V18ZM5 21C4.44772 21 4 20.5523 4 20V9.5C4 9.18524 4.14819 8.88885 4.4 8.7L11.4 3.45C11.7556 3.18333 12.2444 3.18333 12.6 3.45L19.6 8.7C19.8518 8.88885 20 9.18524 20 9.5V20C20 20.5523 19.5523 21 19 21H14C13.4477 21 13 20.5523 13 20V16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16V20C11 20.5523 10.5523 21 10 21H5Z"
                fill="#BBBBBB"/>
        </g>
        <defs>
          <clipPath id="clip0_10959_4494">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    ),
    iconSelect: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_18071_1177)">
          <path d="M12.6 3.45C12.2444 3.18333 11.7556 3.18333 11.4 3.45L4.4 8.7C4.14819 8.88885 4 9.18524 4 9.5V20C4 20.5523 4.44772 21 5 21H8C8.55228 21 9 20.5523 9 20V15C9 14.4477 9.44772 14 10 14H14C14.5523 14 15 14.4477 15 15V20C15 20.5523 15.4477 21 16 21H19C19.5523 21 20 20.5523 20 20V9.5C20 9.18524 19.8518 8.88885 19.6 8.7L12.6 3.45Z"
            fill="#343A3D"/>
        </g>
        <defs>
          <clipPath id="clip0_18071_1177">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    ),
    iconHover: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
           fill="none">
        <g clipPath="url(#clip0_18071_1177)">
          <path
            d="M12.6 3.45C12.2444 3.18333 11.7556 3.18333 11.4 3.45L4.4 8.7C4.14819 8.88885 4 9.18524 4 9.5V20C4 20.5523 4.44772 21 5 21H8C8.55228 21 9 20.5523 9 20V15C9 14.4477 9.44772 14 10 14H14C14.5523 14 15 14.4477 15 15V20C15 20.5523 15.4477 21 16 21H19C19.5523 21 20 20.5523 20 20V9.5C20 9.18524 19.8518 8.88885 19.6 8.7L12.6 3.45Z"
            fill="#FF861A"/>
        </g>
        <defs>
          <clipPath id="clip0_18071_1177">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    )
  },
  {
    name: "求人情報",
    path: "/talent/job",
    childPath: [
      "/talent/job/detail/:id",
    ],
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
           fill="none">
        <g clipPath="url(#clip0_18071_6078)">
          <path fillRule="evenodd" clipRule="evenodd"
                d="M14 6V4H10V6H14ZM4 8V19H20V8H4ZM20 6C21.11 6 22 6.89 22 8V19C22 20.11 21.11 21 20 21H4C2.89 21 2 20.11 2 19L2.01 8C2.01 6.89 2.89 6 4 6H8V4C8 2.89 8.89 2 10 2H14C15.11 2 16 2.89 16 4V6H20Z"
                fill="#BBBBBB"/>
        </g>
        <defs>
          <clipPath id="clip0_18071_6078">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    ),
    iconSelect: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_18071_5427)">
          <path d="M20 6H16V4C16 2.89 15.11 2 14 2H10C8.89 2 8 2.89 8 4V6H4C2.89 6 2.01 6.89 2.01 8L2 19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V8C22 6.89 21.11 6 20 6ZM14 6H10V4H14V6Z"
            fill="#343A3D"/>
        </g>
        <defs>
          <clipPath id="clip0_18071_5427">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    ),
    iconHover: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
           fill="none">
        <g clipPath="url(#clip0_18071_5427)">
          <path
            d="M20 6H16V4C16 2.89 15.11 2 14 2H10C8.89 2 8 2.89 8 4V6H4C2.89 6 2.01 6.89 2.01 8L2 19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V8C22 6.89 21.11 6 20 6ZM14 6H10V4H14V6Z"
            fill="#FF861A"/>
        </g>
        <defs>
          <clipPath id="clip0_18071_5427">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    )
  },
  {
    name: "メッセージ",
    path: "/talent/message",
    noti: 0,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
           fill="none">
        <g clipPath="url(#clip0_18071_6084)">
          <path
            d="M18.3749 4.5H5.17494C4.26744 4.5 3.52494 5.2425 3.52494 6.15V21L6.82494 17.7H18.3749C19.2824 17.7 20.0249 16.9575 20.0249 16.05V6.15C20.0249 5.2425 19.2824 4.5 18.3749 4.5ZM18.3749 15.75H6.82494L5.39994 17.25V6.375H18.3749V15.75Z"
            fill="#BBBBBB"/>
        </g>
        <defs>
          <clipPath id="clip0_18071_6084">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    ),
    iconSelect: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_18071_5287)">
          <path d="M18.6 4.5H5.4C4.4925 4.5 3.75 5.2425 3.75 6.15V21L7.05 17.7H18.6C19.5075 17.7 20.25 16.9575 20.25 16.05V6.15C20.25 5.2425 19.5075 4.5 18.6 4.5Z"
            fill="#343A3D"/>
        </g>
        <defs>
          <clipPath id="clip0_18071_5287">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    ),
    iconHover: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
           fill="none">
        <g clipPath="url(#clip0_18071_5287)">
          <path
            d="M18.6 4.5H5.4C4.4925 4.5 3.75 5.2425 3.75 6.15V21L7.05 17.7H18.6C19.5075 17.7 20.25 16.9575 20.25 16.05V6.15C20.25 5.2425 19.5075 4.5 18.6 4.5Z"
            fill="#FF861A"/>
        </g>
        <defs>
          <clipPath id="clip0_18071_5287">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    )
  },
  {
    name: "友だちを招待",
    path: "",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#BBBBBB"><path d="M520-120v-80h80v80h-80Zm-80-80v-200h80v200h-80Zm320-120v-160h80v160h-80Zm-80-160v-80h80v80h-80Zm-480 80v-80h80v80h-80Zm-80-80v-80h80v80h-80Zm360-280v-80h80v80h-80ZM180-660h120v-120H180v120Zm-60 60v-240h240v240H120Zm60 420h120v-120H180v120Zm-60 60v-240h240v240H120Zm540-540h120v-120H660v120Zm-60 60v-240h240v240H600Zm80 480v-120h-80v-80h160v120h80v80H680ZM520-400v-80h160v80H520Zm-160 0v-80h-80v-80h240v80h-80v80h-80Zm40-200v-160h80v80h80v80H400Zm-190-90v-60h60v60h-60Zm0 480v-60h60v60h-60Zm480-480v-60h60v60h-60Z"/></svg>
    ),
    iconSelect: (
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#343A3D"><path d="M520-120v-80h80v80h-80Zm-80-80v-200h80v200h-80Zm320-120v-160h80v160h-80Zm-80-160v-80h80v80h-80Zm-480 80v-80h80v80h-80Zm-80-80v-80h80v80h-80Zm360-280v-80h80v80h-80ZM180-660h120v-120H180v120Zm-60 60v-240h240v240H120Zm60 420h120v-120H180v120Zm-60 60v-240h240v240H120Zm540-540h120v-120H660v120Zm-60 60v-240h240v240H600Zm80 480v-120h-80v-80h160v120h80v80H680ZM520-400v-80h160v80H520Zm-160 0v-80h-80v-80h240v80h-80v80h-80Zm40-200v-160h80v80h80v80H400Zm-190-90v-60h60v60h-60Zm0 480v-60h60v60h-60Zm480-480v-60h60v60h-60Z"/></svg>
    ),
    iconHover: (
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FF861A"><path d="M520-120v-80h80v80h-80Zm-80-80v-200h80v200h-80Zm320-120v-160h80v160h-80Zm-80-160v-80h80v80h-80Zm-480 80v-80h80v80h-80Zm-80-80v-80h80v80h-80Zm360-280v-80h80v80h-80ZM180-660h120v-120H180v120Zm-60 60v-240h240v240H120Zm60 420h120v-120H180v120Zm-60 60v-240h240v240H120Zm540-540h120v-120H660v120Zm-60 60v-240h240v240H600Zm80 480v-120h-80v-80h160v120h80v80H680ZM520-400v-80h160v80H520Zm-160 0v-80h-80v-80h240v80h-80v80h-80Zm40-200v-160h80v80h80v80H400Zm-190-90v-60h60v60h-60Zm0 480v-60h60v60h-60Zm480-480v-60h60v60h-60Z"/></svg>
    )
  },
  {
    name: "マイページ",
    path: "/talent/mypage",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
           fill="none">
        <g clipPath="url(#clip0_18071_5297)">
          <path
            d="M12 5.9C13.16 5.9 14.1 6.84 14.1 8C14.1 9.16 13.16 10.1 12 10.1C10.84 10.1 9.9 9.16 9.9 8C9.9 6.84 10.84 5.9 12 5.9ZM12 14.9C14.97 14.9 18.1 16.36 18.1 17V17.1C18.1 17.6523 17.6523 18.1 17.1 18.1H6.9C6.34771 18.1 5.9 17.6523 5.9 17.1V17C5.9 16.36 9.03 14.9 12 14.9ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM12 13C9.33 13 4 14.34 4 17V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V17C20 14.34 14.67 13 12 13Z"
            fill="#BBBBBB"/>
        </g>
        <defs>
          <clipPath id="clip0_18071_5297">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    ),
    iconSelect: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_18071_27246)">
          <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V18C20 15.34 14.67 14 12 14Z"
            fill="#343A3D"/>
        </g>
        <defs>
          <clipPath id="clip0_18071_27246">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    ),
    iconHover: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
           fill="none">
        <g clipPath="url(#clip0_18071_27246)">
          <path
            d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V18C20 15.34 14.67 14 12 14Z"
            fill="#FF861A"/>
        </g>
        <defs>
          <clipPath id="clip0_18071_27246">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    )
  },
];

const MenuItem = ({item, isItemSelected}: any) => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const [isHovered, setIsHovered] = useState(false);
  const {numberOfTalentMessage, chatList} = useSelector((state: any) => state.chatMessage);

  const handleClick = (e: React.MouseEvent, path: string) => {
    if(path == "/talent/message") {
      dispatch(setOpenChatListModal(true));
      return;
    }
    if(path == "") {
      e.preventDefault();
      dispatch(setShowReferralPopup(true));
      return;
    }

    dispatch(setIsSameChatSelected(true));
    dispatch(setMessages([]));
    dispatch(setChatSelected({}));
    dispatch(setStaffSelected({}));
    dispatch(setJobSelected({}));
    dispatch(setIsPaging(false));
    if(chatList.length > 0) {
      dispatch(setIsLoadNewListChat(false));
    }
    dispatch(setIsNewChatFormOtherScreen(false));
  };

  return (
    <Link className="flex-1" to={item?.path} onClick={(e) => handleClick(e, item.path)}>
      <li onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className={`relative md:h-12 md:px-3 md:py-[0.875rem] rounded flex items-center justify-between gap-1 ${
            !isItemSelected ? "md:hover:bg-[#FFF3E5] hover:cursor-pointer group" : "hover:cursor-default"
          } ${!item?.name ? "invisible" : ""}`}
      >
        <div
          className={`w-full text-xs md:text-sm leading-[1.3125rem] font-bold flex flex-col md:group-hover:text-[#FF861A] md:inline-flex md:flex-row md:items-end items-center gap-1 ${
            !isItemSelected ? "text-[#BBB] md:text-[#808080]" : "alu-text-base-2"
          }`}
        >
          <span
            className={`${
              !isItemSelected ? "text-[#BBB]" : "text-[#343A3D]"
            } md:group-hover:text-[#FF861A]`}
          >
            {isItemSelected ? item.iconSelect : isHovered ? item.iconHover : item.icon}
          </span>
          <p>{item?.name}</p>
        </div>
        {item?.noti != undefined && numberOfTalentMessage != 0 && (
          <span className="absolute md:static top-[2px] right-[32%]">
            <svg
              className="w-[0.5625rem] h-8 md:w-1 md:h:4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 4 16"
              fill="none"
            >
              <circle cx="2" cy="2" r="2" fill="#FF861A" />
            </svg>
          </span>
        )}
      </li>
    </Link>
  );
};

const TalentSideMenu = () => {
  const location = useLocation();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const [menuItems, setMenuItems] = useState(defaultMenuItems);
  const { isShowReferralPopup } = useSelector((state: any) => state.friendInvitation);
  const { talentInfo } = useSelector((state: any) => state.currentUser);
  const hasCompanySlugURL = talentInfo && talentInfo?.company?.url_slug; // check if the menu should show friend referral item
  const hasCompanyRegisterLinks = talentInfo && talentInfo?.company?.register_links && talentInfo?.company?.register_links.length >= 2; // check if the menu should show friend referral item
  const [imagesLoaded, setImagesLoaded] = useState(false);

  const imageList = [friendImg1, friendImg2, qrBackground];

  useEffect(() => {
    let loadedCount = 0;

    imageList.forEach((src) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        loadedCount++;
        if (loadedCount === imageList.length) {
          setImagesLoaded(true);
        }
      };
    });
  }, []);

  useEffect(() => {
    // Get number of messages not read
    dispatch(getNumberMessagesTalent(""));
  }, []);

  const checkMenuItems = () => {
    if (window.innerWidth < 768) {
      if(hasCompanySlugURL && hasCompanyRegisterLinks) {
        setMenuItems(mobileMenuItems);
      } else {
        setMenuItems(mobileMenuItems.filter(item => item.path !== ""));
      }
    } else {
      if(hasCompanySlugURL && hasCompanyRegisterLinks) {
        setMenuItems(defaultMenuItems);
      } else {
        setMenuItems(defaultMenuItems.filter(item => item.path !== ""));
      }
    }
  };

  useEffect(() => {
    const handleResize = () => {
      // Check if the screen width is less than 768px (mobile)
      checkMenuItems();
    };

    // Set the initial state
    handleResize();

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    checkMenuItems();
  }, [talentInfo]);

  const isJobDetailPage = (path) => {
    return path.startsWith('/talent/job/detail/');
  };

  const isTalentNewsPage = (path) => {
    return path.startsWith('/talent/news/');
  }

  return (
    <>
      <ul
        className="fixed md:relative h-max bg-white lg:px-2 pt-1 pb-1 md:p-8 flex md:flex-col md:gap-2 md:rounded-2xl alu-panel-box-shadow md:alu-section-box-shadow shrink-0 left-0 bottom-0 z-20 w-full md:w-auto justify-between max-md:[padding-bottom:calc(0.25rem+env(safe-area-inset-bottom,0px))]"
      >
        {menuItems.map((item, idx) => (
          <MenuItem
            key={idx}
            item={item}
            isItemSelected={
              location.pathname === item.path ||
              (item.path === "/talent" && location.pathname === "/talent/") ||
              (item.path === "/talent" && isTalentNewsPage(location.pathname)) ||
              (item.path === "/talent/job" && isJobDetailPage(location.pathname)) ||
              (item.childPath && item.childPath.some(childPath => {
                const regex = new RegExp(`^${childPath.replace(/\/:\w+$/, '/\\d+')}$`);
                return regex.test(location.pathname);
              }))
            }
          />
        ))}
      </ul>
      {isShowReferralPopup && (
        <FriendReferralPopup
          open={isShowReferralPopup && imagesLoaded}
          onClose={() => {
            dispatch(setShowReferralPopup(false));
          }}
          images={{ friendImg1, friendImg2, qrBackground }}
        />
      )}
    </>
  );
};

export default TalentSideMenu;
